/** Single call site for all third-party integration initialisation. Add new integrations here. */

import * as Sentry from "@sentry/react";
import { initializeProgressiveDelivery } from "./delivery";

/** Initialises all third-party integrations. Call once on app boot before rendering. */
export function initIntegrations(): void {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN as string | undefined,
    enabled: import.meta.env.PROD,
    // VITE_ENVIRONMENT is set per Doppler config (development / production) so the dev-hosted
    // site doesn't tag its errors "production" — `vite build` always sets MODE to "production"
    // regardless of deploy target, so MODE alone can't distinguish them. Falls back to MODE for
    // local `doppler run -- npm run dev` without rc-platform configured.
    environment: (import.meta.env.VITE_ENVIRONMENT as string | undefined) ?? import.meta.env.MODE,
    release: import.meta.env.VITE_APP_VERSION as string | undefined,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    attachStacktrace: true,
    tracesSampleRate: 0.2,
    replaysSessionSampleRate: 0.05,
    replaysOnErrorSampleRate: 1.0,
    beforeSend(event) {
      // Strip request body data from API call breadcrumbs to avoid
      // sending user claim text or URL content to Sentry.
      event.breadcrumbs?.forEach((b) => {
        if (b.category === "api" || b.category === "fetch") {
          delete b.data?.["body"];
          delete b.data?.["request_body_size"];
        }
      });
      return event;
    },
  });

  initializeProgressiveDelivery();
}
